export default [
  { title: "Home", text: "Home" },
  { title: "About", text: "About" },
  { title: "Books", text: "Books" },
  { title: "Cards", text: "Cards" },
  { title: "Cart", text: "Cart" },
  { title: "Facts", text: "Facts" },
  { title: "Feature", text: "Feature" }
];
